// Generated by HubGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html



import {SpinnerService} from './SpinnerModule';
import {HubProxy} from './HubProxyModule';
import {ConfigService} from "./ConfigModule";
import {DisposeBag} from "./DisposeBag";
import {IQService, IRootScopeService, ITimeoutService, IWindowService, IDeferred} from "angular";
import {Guid} from "guid-typescript";
import { ActivityDto } from '../model/ActivityDto';
import { ActivityFullDto } from '../model/ActivityFullDto';
import { ActivityTypeDto } from '../model/ActivityTypeDto';
import { CaseDto } from '../model/CaseDto';
import { CaseTypeDto } from '../model/CaseTypeDto';
import { QbCustomerContactDto } from '../model/QbCustomerContactDto';
import { QbDataExtensionDefinitionDto } from '../model/QbDataExtensionDefinitionDto';
import { QbNameResultDto } from '../model/QbNameResultDto';
import { CustomerTagGroupDto } from '../model/CustomerTagGroupDto';
import { LeadSourceDto } from '../model/LeadSourceDto';
import { LeadStatusDto } from '../model/LeadStatusDto';
import { QbCustomerDto } from '../model/QbCustomerDto';
import { ReceivePaymentDto } from '../model/ReceivePaymentDto';
import { QbReceivePaymentDetailDto } from '../model/QbReceivePaymentDetailDto';
import { AuthNetHostedProfilePageTokenResultDto } from '../model/AuthNetHostedProfilePageTokenResultDto';
import { QbClassDto } from '../model/QbClassDto';
import { QbCustomerMsgDto } from '../model/QbCustomerMsgDto';
import { QbItemSalesTaxDto } from '../model/QbItemSalesTaxDto';
import { QbPriceLevelDto } from '../model/QbPriceLevelDto';
import { QbSalesRepDto } from '../model/QbSalesRepDto';
import { QbSalesTaxCodeDto } from '../model/QbSalesTaxCodeDto';
import { QbSyncStateDto } from '../model/QbSyncStateDto';
import { QbTemplateDto } from '../model/QbTemplateDto';
import { QbTermsDto } from '../model/QbTermsDto';
import { QbTransactionDto } from '../model/QbTransactionDto';
import { QbXmlRequestDto } from '../model/QbXmlRequestDto';
import { UserFullDto } from '../model/UserFullDto';
import { ActivityCreateDto } from '../model/ActivityCreateDto';
import { ActivityFollowupDto } from '../model/ActivityFollowupDto';
import { ActivityQueryDto } from '../model/ActivityQueryDto';
import { ActivityTimeDto } from '../model/ActivityTimeDto';
import { ActivityUpdateDto } from '../model/ActivityUpdateDto';
import { XheoActivationDto } from '../model/XheoActivationDto';
import { AssetLicenseAddOrUpdateDto } from '../model/AssetLicenseAddOrUpdateDto';
import { AssetNoteAddDto } from '../model/AssetNoteAddDto';
import { AssetAddOrUpdateDto } from '../model/AssetAddOrUpdateDto';
import { AssetTransactionAddOrUpdateDto } from '../model/AssetTransactionAddOrUpdateDto';
import { AsteriskCallBackStatus } from '../model/AsteriskCallBackStatus';
import { CompanyDto } from '../model/CompanyDto';
import { AuthorizeNetPaymentProfileDto } from '../model/AuthorizeNetPaymentProfileDto';
import { QbCustomerEditDto } from '../model/QbCustomerEditDto';
import { QbCustomerPaymentMigrationDto } from '../model/QbCustomerPaymentMigrationDto';
import { QbInvoiceAutoDebitDto } from '../model/QbInvoiceAutoDebitDto';
import { LocationDto } from '../model/LocationDto';
import { AuthNetHostedProfilePageTokenRequestDto } from '../model/AuthNetHostedProfilePageTokenRequestDto';
import { AuthorizeNetCustomerProfileDto } from '../model/AuthorizeNetCustomerProfileDto';
import { AuthorizeNetTransactionDto } from '../model/AuthorizeNetTransactionDto';
import { QbReceivePaymentDto } from '../model/QbReceivePaymentDto';
import { TxnTemplateDto } from '../model/TxnTemplateDto';
import { UserActivityDto } from '../model/UserActivityDto';
import { XheoExtensionDto } from '../model/XheoExtensionDto';
import { AssetEmailLogDto } from '../model/AssetEmailLogDto';
import { AssetEnabledFeatureDto } from '../model/AssetEnabledFeatureDto';
import { AssetLicenseDto } from '../model/AssetLicenseDto';
import { AssetNoteDto } from '../model/AssetNoteDto';
import { AssetPricePlanDto } from '../model/AssetPricePlanDto';
import { AssetProductDto } from '../model/AssetProductDto';
import { AssetDto } from '../model/AssetDto';
import { AssetStatusDto } from '../model/AssetStatusDto';
import { AssetTransactionDto } from '../model/AssetTransactionDto';
import { AssetTypeDto } from '../model/AssetTypeDto';
import { AuthorizeNetBatchDto } from '../model/AuthorizeNetBatchDto';
import { CasePriorityDto } from '../model/CasePriorityDto';
import { CaseStatusDto } from '../model/CaseStatusDto';
import { QbCustomerFullDto } from '../model/QbCustomerFullDto';
import { CustomerSearchDto } from '../model/CustomerSearchDto';
import { QbInvoiceDetailDto } from '../model/QbInvoiceDetailDto';
import { QbItemServiceDto } from '../model/QbItemServiceDto';
import { LogDto } from '../model/LogDto';
import { QbPaymentMethodDto } from '../model/QbPaymentMethodDto';
import { QbItemDto } from '../model/QbItemDto';
import { TxnTemplateWithHistoryDto } from '../model/TxnTemplateWithHistoryDto';
import { XheoDebugLogDto } from '../model/XheoDebugLogDto';

export class DataHub extends HubProxy {

    constructor($q: IQService,
                $rootScope: IRootScopeService,
                $timeout: ITimeoutService,
                $window: IWindowService,
                $spinner: SpinnerService,
                $config: ConfigService,
                logging: boolean) {
        super($q, $rootScope, $timeout, $window, $spinner, $config, 'DataHub', logging);
    }

    // server methods

    
    activityComplete = (activityGuid: string|Guid) => {
        return this.invoke<void>('ActivityComplete', activityGuid);
    }
    
    activityCreate = (dto: ActivityCreateDto) => {
        return this.invoke<ActivityDto>('ActivityCreate', dto);
    }
    
    activityCreateFollowup = (dto: ActivityFollowupDto) => {
        return this.invoke<ActivityDto>('ActivityCreateFollowup', dto);
    }
    
    activityFullSubscribeAndQuery = (activityGuid: string|Guid) => {
        return this.invoke<ActivityFullDto>('ActivityFullSubscribeAndQuery', activityGuid);
    }
    
    activityStart = (activityGuid: string|Guid) => {
        return this.invoke<void>('ActivityStart', activityGuid);
    }
    
    activityStop = (activityGuid: string|Guid) => {
        return this.invoke<void>('ActivityStop', activityGuid);
    }
    
    activitySubscribeAndQuery = (dto: ActivityQueryDto) => {
        return this.invoke<ActivityDto[]>('ActivitySubscribeAndQuery', dto);
    }
    
    activityTimeDelete = (dto: ActivityTimeDto) => {
        return this.invoke<void>('ActivityTimeDelete', dto);
    }
    
    activityTimeUpdate = (dto: ActivityTimeDto) => {
        return this.invoke<void>('ActivityTimeUpdate', dto);
    }
    
    activityTypeSubscribeAndQuery = () => {
        return this.invoke<ActivityTypeDto[]>('ActivityTypeSubscribeAndQuery', );
    }
    
    activityUpdate = (dto: ActivityUpdateDto) => {
        return this.invoke<void>('ActivityUpdate', dto);
    }
    
    assetActivationDelete = (dto: XheoActivationDto) => {
        return this.invoke<void>('AssetActivationDelete', dto);
    }
    
    assetActivationReset = (dto: XheoActivationDto) => {
        return this.invoke<void>('AssetActivationReset', dto);
    }
    
    assetActivationSub = (assetGuid: string|Guid) => {
        return this.invoke<void>('AssetActivationSub', assetGuid);
    }
    
    assetEmailLogSub = (assetGuid: string|Guid) => {
        return this.invoke<void>('AssetEmailLogSub', assetGuid);
    }
    
    assetEnabledFeatureSub = (assetGuid: string|Guid) => {
        return this.invoke<void>('AssetEnabledFeatureSub', assetGuid);
    }
    
    assetLicenseSave = (dto: AssetLicenseAddOrUpdateDto) => {
        return this.invoke<void>('AssetLicenseSave', dto);
    }
    
    assetLicenseSub = (assetGuid: string|Guid) => {
        return this.invoke<void>('AssetLicenseSub', assetGuid);
    }
    
    assetNoteSave = (dto: AssetNoteAddDto) => {
        return this.invoke<void>('AssetNoteSave', dto);
    }
    
    assetNoteSub = (assetGuid: string|Guid) => {
        return this.invoke<void>('AssetNoteSub', assetGuid);
    }
    
    assetPricePlanSub = () => {
        return this.invoke<void>('AssetPricePlanSub', );
    }
    
    assetProductSub = () => {
        return this.invoke<void>('AssetProductSub', );
    }
    
    assetReport = (reportName: string) => {
        return this.invoke<void>('AssetReport', reportName);
    }
    
    assetSave = (dto: AssetAddOrUpdateDto) => {
        return this.invoke<string>('AssetSave', dto);
    }
    
    assetSearch = (search: string) => {
        return this.invoke<void>('AssetSearch', search);
    }
    
    assetStatusSub = () => {
        return this.invoke<void>('AssetStatusSub', );
    }
    
    assetSub = (assetGuid: string|Guid) => {
        return this.invoke<void>('AssetSub', assetGuid);
    }
    
    assetSync = () => {
        return this.invoke<void>('AssetSync', );
    }
    
    assetTransactionSave = (dto: AssetTransactionAddOrUpdateDto) => {
        return this.invoke<void>('AssetTransactionSave', dto);
    }
    
    assetTransactionSub = (assetGuid: string|Guid) => {
        return this.invoke<void>('AssetTransactionSub', assetGuid);
    }
    
    assetTypeSub = () => {
        return this.invoke<void>('AssetTypeSub', );
    }
    
    assetValidate = (assetGuid: string|Guid) => {
        return this.invoke<void>('AssetValidate', assetGuid);
    }
    
    asteriskCallBackStatusUpdate = (callGuid: string|Guid, status: AsteriskCallBackStatus) => {
        return this.invoke<void>('AsteriskCallBackStatusUpdate', callGuid, status);
    }
    
    asteriskCallDetailSubscribe = (callGuid: string|Guid) => {
        return this.invoke<void>('AsteriskCallDetailSubscribe', callGuid);
    }
    
    asteriskCallNoteUpdate = (callGuid: string|Guid, note: string) => {
        return this.invoke<void>('AsteriskCallNoteUpdate', callGuid, note);
    }
    
    asteriskCallOriginate = (extension: string, number: string) => {
        return this.invoke<void>('AsteriskCallOriginate', extension, number);
    }
    
    asteriskCallSubscribe = (callDate: Date) => {
        return this.invoke<void>('AsteriskCallSubscribe', callDate);
    }
    
    asteriskCallTagAdd = (callGuid: string|Guid, tag: string) => {
        return this.invoke<void>('AsteriskCallTagAdd', callGuid, tag);
    }
    
    asteriskCallTagRemove = (callGuid: string|Guid, tag: string) => {
        return this.invoke<void>('AsteriskCallTagRemove', callGuid, tag);
    }
    
    asteriskCallTagSearch = (input: string) => {
        return this.invoke<string[]>('AsteriskCallTagSearch', input);
    }
    
    asteriskCallUnlink = (callGuid: string|Guid, linkGuid: string|Guid) => {
        return this.invoke<void>('AsteriskCallUnlink', callGuid, linkGuid);
    }
    
    asteriskQueueMemberSubscribe = () => {
        return this.invoke<void>('AsteriskQueueMemberSubscribe', );
    }
    
    casePrioritySubscribe = () => {
        return this.invoke<void>('CasePrioritySubscribe', );
    }
    
    caseSave = (caseDto: CaseDto) => {
        return this.invoke<CaseDto>('CaseSave', caseDto);
    }
    
    caseStatusSubscribe = () => {
        return this.invoke<void>('CaseStatusSubscribe', );
    }
    
    caseSubscribe = (caseGuid: string|Guid) => {
        return this.invoke<void>('CaseSubscribe', caseGuid);
    }
    
    caseTypeSave = (caseType: CaseTypeDto) => {
        return this.invoke<CaseTypeDto>('CaseTypeSave', caseType);
    }
    
    caseTypeSubscribe = () => {
        return this.invoke<void>('CaseTypeSubscribe', );
    }
    
    companySave = (company: CompanyDto) => {
        return this.invoke<void>('CompanySave', company);
    }
    
    companySubscribe = (companyGuid: string|Guid) => {
        return this.invoke<void>('CompanySubscribe', companyGuid);
    }
    
    contactDelete = (dto: QbCustomerContactDto) => {
        return this.invoke<void>('ContactDelete', dto);
    }
    
    contactSave = (dto: QbCustomerContactDto) => {
        return this.invoke<string>('ContactSave', dto);
    }
    
    contactSubscribeAndQuery = (customerGuid: string|Guid) => {
        return this.invoke<QbCustomerContactDto[]>('ContactSubscribeAndQuery', customerGuid);
    }
    
    customerAssetSubscribe = (customerGuid: string|Guid) => {
        return this.invoke<void>('CustomerAssetSubscribe', customerGuid);
    }
    
    customerAutoDebitPaymentProfileUpdate = (customer: QbCustomerDto, profile: AuthorizeNetPaymentProfileDto) => {
        return this.invoke<void>('CustomerAutoDebitPaymentProfileUpdate', customer, profile);
    }
    
    customerDataExtensionList = () => {
        return this.invoke<QbDataExtensionDefinitionDto[]>('CustomerDataExtensionList', );
    }
    
    customerGet = (customerGuid: string|Guid) => {
        return this.invoke<void>('CustomerGet', customerGuid);
    }
    
    customerJobSearch = (requestId: any, query: string, limit: number) => {
        return this.invoke<void>('CustomerJobSearch', requestId, query, limit);
    }
    
    customerNameValidate = (dto: QbCustomerEditDto) => {
        return this.invoke<QbNameResultDto>('CustomerNameValidate', dto);
    }
    
    customerPaymentMigrationRemove = (dto: QbCustomerPaymentMigrationDto) => {
        return this.invoke<void>('CustomerPaymentMigrationRemove', dto);
    }
    
    customerPaymentMigrationSave = (dto: QbCustomerPaymentMigrationDto) => {
        return this.invoke<void>('CustomerPaymentMigrationSave', dto);
    }
    
    customerPaymentMigrationSub = () => {
        return this.invoke<void>('CustomerPaymentMigrationSub', );
    }
    
    customerSave = (dto: QbCustomerEditDto) => {
        return this.invoke<string>('CustomerSave', dto);
    }
    
    customerSearch = (requestId: any, query: string, parentGuid: string|Guid, limit: number) => {
        return this.invoke<void>('CustomerSearch', requestId, query, parentGuid, limit);
    }
    
    customerSearch2 = (query: string, requestId: any) => {
        return this.invoke<void>('CustomerSearch2', query, requestId);
    }
    
    customerSubSave = (customer: QbCustomerDto) => {
        return this.invoke<void>('CustomerSubSave', customer);
    }
    
    customerTagGroupSubscribeAndQuery = () => {
        return this.invoke<CustomerTagGroupDto[]>('CustomerTagGroupSubscribeAndQuery', );
    }
    
    customerTagGroupUpdate = (dto: CustomerTagGroupDto) => {
        return this.invoke<void>('CustomerTagGroupUpdate', dto);
    }
    
    invoiceAutoDebit = (dto: QbInvoiceAutoDebitDto) => {
        return this.invoke<void>('InvoiceAutoDebit', dto);
    }
    
    invoiceAutoDebitProcessAll = () => {
        return this.invoke<void>('InvoiceAutoDebitProcessAll', );
    }
    
    invoiceAutoDebitSub = () => {
        return this.invoke<void>('InvoiceAutoDebitSub', );
    }
    
    invoiceDetailSubscribe = (invoiceGuid: string|Guid) => {
        return this.invoke<void>('InvoiceDetailSubscribe', invoiceGuid);
    }
    
    itemServiceGet = () => {
        return this.invoke<void>('ItemServiceGet', );
    }
    
    itemServiceSearch = (requestId: any, query: string) => {
        return this.invoke<void>('ItemServiceSearch', requestId, query);
    }
    
    leadSourceSubscribeAndQuery = () => {
        return this.invoke<LeadSourceDto[]>('LeadSourceSubscribeAndQuery', );
    }
    
    leadStatusSubscribeAndQuery = () => {
        return this.invoke<LeadStatusDto[]>('LeadStatusSubscribeAndQuery', );
    }
    
    leadSubscribeAndQuery = (isActive: boolean) => {
        return this.invoke<QbCustomerDto[]>('LeadSubscribeAndQuery', isActive);
    }
    
    locationGet = (cust: QbCustomerDto) => {
        return this.invoke<void>('LocationGet', cust);
    }
    
    locationSave = (location: LocationDto) => {
        return this.invoke<void>('LocationSave', location);
    }
    
    logSubscribe = () => {
        return this.invoke<void>('LogSubscribe', );
    }
    
    paymentBatchSubscribe = () => {
        return this.invoke<void>('PaymentBatchSubscribe', );
    }
    
    paymentBatchSync = () => {
        return this.invoke<void>('PaymentBatchSync', );
    }
    
    paymentCreate = (customerGuid: string|Guid) => {
        return this.invoke<ReceivePaymentDto>('PaymentCreate', customerGuid);
    }
    
    paymentDetailSubscribeAndQuery = (paymentGuid: string|Guid) => {
        return this.invoke<QbReceivePaymentDetailDto>('PaymentDetailSubscribeAndQuery', paymentGuid);
    }
    
    paymentGetAuthNetHostedProfilePageToken = (dto: AuthNetHostedProfilePageTokenRequestDto) => {
        return this.invoke<AuthNetHostedProfilePageTokenResultDto>('PaymentGetAuthNetHostedProfilePageToken', dto);
    }
    
    paymentLinkCustomerProfile = (dto: AuthorizeNetCustomerProfileDto) => {
        return this.invoke<void>('PaymentLinkCustomerProfile', dto);
    }
    
    paymentMethodSub = () => {
        return this.invoke<void>('PaymentMethodSub', );
    }
    
    paymentProfileSub = (customerGuid: string|Guid) => {
        return this.invoke<void>('PaymentProfileSub', customerGuid);
    }
    
    paymentSave = (dto: ReceivePaymentDto) => {
        return this.invoke<QbReceivePaymentDetailDto>('PaymentSave', dto);
    }
    
    paymentTransactionCreateProfile = (txn: AuthorizeNetTransactionDto, customer: QbCustomerDto) => {
        return this.invoke<void>('PaymentTransactionCreateProfile', txn, customer);
    }
    
    paymentTransactionsWithoutProfile = () => {
        return this.invoke<void>('PaymentTransactionsWithoutProfile', );
    }
    
    paymentTransactionSync = () => {
        return this.invoke<void>('PaymentTransactionSync', );
    }
    
    paymentUnlinkedProfileSub = () => {
        return this.invoke<void>('PaymentUnlinkedProfileSub', );
    }
    
    paymentUnlinkedTransactionCreate = (txn: AuthorizeNetTransactionDto) => {
        return this.invoke<void>('PaymentUnlinkedTransactionCreate', txn);
    }
    
    paymentUnlinkedTransactionSub = () => {
        return this.invoke<void>('PaymentUnlinkedTransactionSub', );
    }
    
    paymentUnlinkedTransactionUpdate = (txn: AuthorizeNetTransactionDto, pmt: QbReceivePaymentDto) => {
        return this.invoke<void>('PaymentUnlinkedTransactionUpdate', txn, pmt);
    }
    
    paymentValidate = (dto: ReceivePaymentDto) => {
        return this.invoke<ReceivePaymentDto>('PaymentValidate', dto);
    }
    
    qbClassSubscribeAndQuery = () => {
        return this.invoke<QbClassDto[]>('QbClassSubscribeAndQuery', );
    }
    
    qbCustomerMsgSubscribeAndQuery = () => {
        return this.invoke<QbCustomerMsgDto[]>('QbCustomerMsgSubscribeAndQuery', );
    }
    
    qbCustomerSubscribeSearch = (query: string) => {
        return this.invoke<void>('QbCustomerSubscribeSearch', query);
    }
    
    qbItemSalesTaxSubscribeAndQuery = () => {
        return this.invoke<QbItemSalesTaxDto[]>('QbItemSalesTaxSubscribeAndQuery', );
    }
    
    qbItemSubscribeSearch = (query: string) => {
        return this.invoke<void>('QbItemSubscribeSearch', query);
    }
    
    qbPendingSubscribe = (guid: string|Guid) => {
        return this.invoke<void>('QbPendingSubscribe', guid);
    }
    
    qbPriceLevelSubscribeAndQuery = () => {
        return this.invoke<QbPriceLevelDto[]>('QbPriceLevelSubscribeAndQuery', );
    }
    
    qbSalesRepSubscribeAndQuery = () => {
        return this.invoke<QbSalesRepDto[]>('QbSalesRepSubscribeAndQuery', );
    }
    
    qbSalesTaxCodeSubscribeAndQuery = () => {
        return this.invoke<QbSalesTaxCodeDto[]>('QbSalesTaxCodeSubscribeAndQuery', );
    }
    
    qbSyncStateAudit = (dto: QbSyncStateDto) => {
        return this.invoke<void>('QbSyncStateAudit', dto);
    }
    
    qbSyncStateResync = (dto: QbSyncStateDto, newDate: Date) => {
        return this.invoke<void>('QbSyncStateResync', dto, newDate);
    }
    
    qbSyncStatusSubscribeAndQuery = () => {
        return this.invoke<QbSyncStateDto[]>('QbSyncStatusSubscribeAndQuery', );
    }
    
    qbTemplateSubscribeAndQuery = () => {
        return this.invoke<QbTemplateDto[]>('QbTemplateSubscribeAndQuery', );
    }
    
    qbTermsSubscribeAndQuery = () => {
        return this.invoke<QbTermsDto[]>('QbTermsSubscribeAndQuery', );
    }
    
    qbTransactionSubscribeAndQuery = (customerGuid: string|Guid) => {
        return this.invoke<QbTransactionDto[]>('QbTransactionSubscribeAndQuery', customerGuid);
    }
    
    qbXmlRequestCancel = (guid: string|Guid) => {
        return this.invoke<void>('QbXmlRequestCancel', guid);
    }
    
    qbXmlRequestSubscribeAndQuery = () => {
        return this.invoke<QbXmlRequestDto[]>('QbXmlRequestSubscribeAndQuery', );
    }
    
    qbXmlRequestSubscribeOne = (guid: string|Guid) => {
        return this.invoke<QbXmlRequestDto>('QbXmlRequestSubscribeOne', guid);
    }
    
    txnTemplateModify = (dto: TxnTemplateDto) => {
        return this.invoke<void>('TxnTemplateModify', dto);
    }
    
    txnTemplateProcessOne = (txnTemplateGuid: string|Guid) => {
        return this.invoke<void>('TxnTemplateProcessOne', txnTemplateGuid);
    }
    
    txnTemplateReviewClear = (txnTemplateGuid: string|Guid) => {
        return this.invoke<void>('TxnTemplateReviewClear', txnTemplateGuid);
    }
    
    txnTemplateSubscribe = (customerGuid: string|Guid) => {
        return this.invoke<void>('TxnTemplateSubscribe', customerGuid);
    }
    
    txnTemplateSubscribeOne = (txnTemplateGuid: string|Guid) => {
        return this.invoke<void>('TxnTemplateSubscribeOne', txnTemplateGuid);
    }
    
    userActivityForceClose = (dto: UserActivityDto) => {
        return this.invoke<void>('UserActivityForceClose', dto);
    }
    
    userActivityForceRefresh = (dto: UserActivityDto) => {
        return this.invoke<void>('UserActivityForceRefresh', dto);
    }
    
    userActivitySubscribe = () => {
        return this.invoke<void>('UserActivitySubscribe', );
    }
    
    userActivityUpdate = (dto: UserActivityDto) => {
        return this.invoke<void>('UserActivityUpdate', dto);
    }
    
    userSubscribeAndQuery = () => {
        return this.invoke<UserFullDto[]>('UserSubscribeAndQuery', );
    }
    
    xheoDebugLogSub = (licenseNumber: string) => {
        return this.invoke<void>('XheoDebugLogSub', licenseNumber);
    }
    
    xheoExtensionSave = (dto: XheoExtensionDto) => {
        return this.invoke<void>('XheoExtensionSave', dto);
    }
    
    xheoExtensionSub = () => {
        return this.invoke<void>('XheoExtensionSub', );
    }
    


    // client methods
    
    /**
    * Wires up a callback to be invoked when ActivityFullRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onActivityFullRemoved = (callback: (arg: ActivityFullDto) => void, bag?: DisposeBag) => {
        let d = this.on('ActivityFullRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ActivityFullUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onActivityFullUpdated = (callback: (arg: ActivityFullDto) => void, bag?: DisposeBag) => {
        let d = this.on('ActivityFullUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ActivityRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onActivityRemoved = (callback: (arg: ActivityDto) => void, bag?: DisposeBag) => {
        let d = this.on('ActivityRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ActivityTypeRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onActivityTypeRemoved = (callback: (arg: ActivityTypeDto) => void, bag?: DisposeBag) => {
        let d = this.on('ActivityTypeRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ActivityTypeUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onActivityTypeUpdated = (callback: (arg: ActivityTypeDto) => void, bag?: DisposeBag) => {
        let d = this.on('ActivityTypeUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ActivityUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onActivityUpdated = (callback: (arg: ActivityDto) => void, bag?: DisposeBag) => {
        let d = this.on('ActivityUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetActivationRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetActivationRemoved = (callback: (arg: XheoActivationDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetActivationRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetActivationUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetActivationUpdated = (callback: (arg: XheoActivationDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetActivationUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetEmailLogRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetEmailLogRemoved = (callback: (arg: AssetEmailLogDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetEmailLogRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetEmailLogUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetEmailLogUpdated = (callback: (arg: AssetEmailLogDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetEmailLogUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetEnabledFeatureRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetEnabledFeatureRemoved = (callback: (arg: AssetEnabledFeatureDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetEnabledFeatureRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetEnabledFeatureUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetEnabledFeatureUpdated = (callback: (arg: AssetEnabledFeatureDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetEnabledFeatureUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetLicenseRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetLicenseRemoved = (callback: (arg: AssetLicenseDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetLicenseRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetLicenseUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetLicenseUpdated = (callback: (arg: AssetLicenseDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetLicenseUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetNoteRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetNoteRemoved = (callback: (arg: AssetNoteDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetNoteRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetNoteUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetNoteUpdated = (callback: (arg: AssetNoteDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetNoteUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetPricePlanRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetPricePlanRemoved = (callback: (arg: AssetPricePlanDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetPricePlanRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetPricePlanUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetPricePlanUpdated = (callback: (arg: AssetPricePlanDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetPricePlanUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetProductRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetProductRemoved = (callback: (arg: AssetProductDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetProductRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetProductUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetProductUpdated = (callback: (arg: AssetProductDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetProductUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetRemoved = (callback: (arg: AssetDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetStatusRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetStatusRemoved = (callback: (arg: AssetStatusDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetStatusRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetStatusUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetStatusUpdated = (callback: (arg: AssetStatusDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetStatusUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetTransactionRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetTransactionRemoved = (callback: (arg: AssetTransactionDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetTransactionRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetTransactionUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetTransactionUpdated = (callback: (arg: AssetTransactionDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetTransactionUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetTypeRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetTypeRemoved = (callback: (arg: AssetTypeDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetTypeRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetTypeUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetTypeUpdated = (callback: (arg: AssetTypeDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetTypeUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AssetUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAssetUpdated = (callback: (arg: AssetDto) => void, bag?: DisposeBag) => {
        let d = this.on('AssetUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AuthorizeNetBatchRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAuthorizeNetBatchRemoved = (callback: (arg: AuthorizeNetBatchDto) => void, bag?: DisposeBag) => {
        let d = this.on('AuthorizeNetBatchRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AuthorizeNetBatchUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAuthorizeNetBatchUpdated = (callback: (arg: AuthorizeNetBatchDto) => void, bag?: DisposeBag) => {
        let d = this.on('AuthorizeNetBatchUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AuthorizeNetTransactionRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAuthorizeNetTransactionRemoved = (callback: (arg: AuthorizeNetTransactionDto) => void, bag?: DisposeBag) => {
        let d = this.on('AuthorizeNetTransactionRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when AuthorizeNetTransactionUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onAuthorizeNetTransactionUpdated = (callback: (arg: AuthorizeNetTransactionDto) => void, bag?: DisposeBag) => {
        let d = this.on('AuthorizeNetTransactionUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CasePriorityRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCasePriorityRemoved = (callback: (arg: CasePriorityDto) => void, bag?: DisposeBag) => {
        let d = this.on('CasePriorityRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CasePriorityUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCasePriorityUpdated = (callback: (priority: CasePriorityDto) => void, bag?: DisposeBag) => {
        let d = this.on('CasePriorityUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CaseRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCaseRemoved = (callback: (arg: CaseDto) => void, bag?: DisposeBag) => {
        let d = this.on('CaseRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CaseStatusRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCaseStatusRemoved = (callback: (arg: CaseStatusDto) => void, bag?: DisposeBag) => {
        let d = this.on('CaseStatusRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CaseStatusUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCaseStatusUpdated = (callback: (status: CaseStatusDto) => void, bag?: DisposeBag) => {
        let d = this.on('CaseStatusUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CaseTypeRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCaseTypeRemoved = (callback: (arg: CaseTypeDto) => void, bag?: DisposeBag) => {
        let d = this.on('CaseTypeRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CaseTypeUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCaseTypeUpdated = (callback: (type: CaseTypeDto) => void, bag?: DisposeBag) => {
        let d = this.on('CaseTypeUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CaseUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCaseUpdated = (callback: (arg: CaseDto) => void, bag?: DisposeBag) => {
        let d = this.on('CaseUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CompanyRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCompanyRemoved = (callback: (arg: CompanyDto) => void, bag?: DisposeBag) => {
        let d = this.on('CompanyRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CompanyUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCompanyUpdated = (callback: (company: CompanyDto) => void, bag?: DisposeBag) => {
        let d = this.on('CompanyUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ContactRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onContactRemoved = (callback: (qbCustomerContactDto: QbCustomerContactDto) => void, bag?: DisposeBag) => {
        let d = this.on('ContactRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ContactUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onContactUpdated = (callback: (qbCustomerContactDto: QbCustomerContactDto) => void, bag?: DisposeBag) => {
        let d = this.on('ContactUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when Customer is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomer = (callback: (customer: QbCustomerFullDto) => void, bag?: DisposeBag) => {
        let d = this.on('Customer', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerAssetRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerAssetRemoved = (callback: (arg: AssetDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerAssetRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerAssetUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerAssetUpdated = (callback: (arg: AssetDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerAssetUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerPaymentMigrationRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerPaymentMigrationRemoved = (callback: (arg: QbCustomerPaymentMigrationDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerPaymentMigrationRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerPaymentMigrationUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerPaymentMigrationUpdated = (callback: (arg: QbCustomerPaymentMigrationDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerPaymentMigrationUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerProfileRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerProfileRemoved = (callback: (arg: AuthorizeNetCustomerProfileDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerProfileRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerProfileUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerProfileUpdated = (callback: (arg: AuthorizeNetCustomerProfileDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerProfileUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerSearchResult is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerSearchResult = (callback: (requestId: any, customer: CustomerSearchDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerSearchResult', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerTagGroupRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerTagGroupRemoved = (callback: (arg: CustomerTagGroupDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerTagGroupRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when CustomerTagGroupUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onCustomerTagGroupUpdated = (callback: (arg: CustomerTagGroupDto) => void, bag?: DisposeBag) => {
        let d = this.on('CustomerTagGroupUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when InvoiceAutoDebitRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onInvoiceAutoDebitRemoved = (callback: (arg: QbInvoiceAutoDebitDto) => void, bag?: DisposeBag) => {
        let d = this.on('InvoiceAutoDebitRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when InvoiceAutoDebitUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onInvoiceAutoDebitUpdated = (callback: (arg: QbInvoiceAutoDebitDto) => void, bag?: DisposeBag) => {
        let d = this.on('InvoiceAutoDebitUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when InvoiceDetailRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onInvoiceDetailRemoved = (callback: (arg: QbInvoiceDetailDto) => void, bag?: DisposeBag) => {
        let d = this.on('InvoiceDetailRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when InvoiceDetailUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onInvoiceDetailUpdated = (callback: (arg: QbInvoiceDetailDto) => void, bag?: DisposeBag) => {
        let d = this.on('InvoiceDetailUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ItemService is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onItemService = (callback: (item: QbItemServiceDto) => void, bag?: DisposeBag) => {
        let d = this.on('ItemService', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ItemServiceSearchResult is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onItemServiceSearchResult = (callback: (item: QbItemServiceDto) => void, bag?: DisposeBag) => {
        let d = this.on('ItemServiceSearchResult', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when LeadRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onLeadRemoved = (callback: (arg: QbCustomerDto) => void, bag?: DisposeBag) => {
        let d = this.on('LeadRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when LeadSourceRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onLeadSourceRemoved = (callback: (arg: LeadSourceDto) => void, bag?: DisposeBag) => {
        let d = this.on('LeadSourceRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when LeadSourceUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onLeadSourceUpdated = (callback: (arg: LeadSourceDto) => void, bag?: DisposeBag) => {
        let d = this.on('LeadSourceUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when LeadStatusRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onLeadStatusRemoved = (callback: (arg: LeadStatusDto) => void, bag?: DisposeBag) => {
        let d = this.on('LeadStatusRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when LeadStatusUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onLeadStatusUpdated = (callback: (arg: LeadStatusDto) => void, bag?: DisposeBag) => {
        let d = this.on('LeadStatusUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when LeadUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onLeadUpdated = (callback: (arg: QbCustomerDto) => void, bag?: DisposeBag) => {
        let d = this.on('LeadUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when Location is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onLocation = (callback: (location: LocationDto) => void, bag?: DisposeBag) => {
        let d = this.on('Location', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when LogUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onLogUpdated = (callback: (arg: LogDto) => void, bag?: DisposeBag) => {
        let d = this.on('LogUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when PaymentDetailRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onPaymentDetailRemoved = (callback: (arg: QbReceivePaymentDetailDto) => void, bag?: DisposeBag) => {
        let d = this.on('PaymentDetailRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when PaymentDetailUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onPaymentDetailUpdated = (callback: (arg: QbReceivePaymentDetailDto) => void, bag?: DisposeBag) => {
        let d = this.on('PaymentDetailUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when PaymentMethodRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onPaymentMethodRemoved = (callback: (arg: QbPaymentMethodDto) => void, bag?: DisposeBag) => {
        let d = this.on('PaymentMethodRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when PaymentMethodUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onPaymentMethodUpdated = (callback: (arg: QbPaymentMethodDto) => void, bag?: DisposeBag) => {
        let d = this.on('PaymentMethodUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when PaymentProfileRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onPaymentProfileRemoved = (callback: (arg: AuthorizeNetPaymentProfileDto) => void, bag?: DisposeBag) => {
        let d = this.on('PaymentProfileRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when PaymentProfileUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onPaymentProfileUpdated = (callback: (arg: AuthorizeNetPaymentProfileDto) => void, bag?: DisposeBag) => {
        let d = this.on('PaymentProfileUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbClassRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbClassRemoved = (callback: (arg: QbClassDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbClassRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbClassUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbClassUpdated = (callback: (arg: QbClassDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbClassUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbCustomerMsgRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbCustomerMsgRemoved = (callback: (arg: QbCustomerMsgDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbCustomerMsgRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbCustomerMsgUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbCustomerMsgUpdated = (callback: (arg: QbCustomerMsgDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbCustomerMsgUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbCustomerRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbCustomerRemoved = (callback: (arg: QbCustomerDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbCustomerRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbCustomerUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbCustomerUpdated = (callback: (arg: QbCustomerDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbCustomerUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbItemRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbItemRemoved = (callback: (arg: QbItemDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbItemRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbItemSalesTaxRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbItemSalesTaxRemoved = (callback: (arg: QbItemSalesTaxDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbItemSalesTaxRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbItemSalesTaxUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbItemSalesTaxUpdated = (callback: (arg: QbItemSalesTaxDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbItemSalesTaxUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbItemUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbItemUpdated = (callback: (arg: QbItemDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbItemUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbPendingChanged is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbPendingChanged = (callback: (count: number) => void, bag?: DisposeBag) => {
        let d = this.on('QbPendingChanged', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbPriceLevelRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbPriceLevelRemoved = (callback: (arg: QbPriceLevelDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbPriceLevelRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbPriceLevelUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbPriceLevelUpdated = (callback: (arg: QbPriceLevelDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbPriceLevelUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbSalesRepRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbSalesRepRemoved = (callback: (arg: QbSalesRepDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbSalesRepRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbSalesRepUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbSalesRepUpdated = (callback: (arg: QbSalesRepDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbSalesRepUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbSalesTaxCodeRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbSalesTaxCodeRemoved = (callback: (arg: QbSalesTaxCodeDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbSalesTaxCodeRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbSalesTaxCodeUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbSalesTaxCodeUpdated = (callback: (arg: QbSalesTaxCodeDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbSalesTaxCodeUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbSyncStateUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbSyncStateUpdated = (callback: (arg: QbSyncStateDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbSyncStateUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbTemplateRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbTemplateRemoved = (callback: (arg: QbTemplateDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbTemplateRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbTemplateUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbTemplateUpdated = (callback: (arg: QbTemplateDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbTemplateUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbTermsRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbTermsRemoved = (callback: (arg: QbTermsDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbTermsRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbTermsUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbTermsUpdated = (callback: (arg: QbTermsDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbTermsUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbTransactionRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbTransactionRemoved = (callback: (arg: QbTransactionDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbTransactionRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbTransactionUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbTransactionUpdated = (callback: (arg: QbTransactionDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbTransactionUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbXmlRequestRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbXmlRequestRemoved = (callback: (arg: QbXmlRequestDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbXmlRequestRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when QbXmlRequestUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onQbXmlRequestUpdated = (callback: (arg: QbXmlRequestDto) => void, bag?: DisposeBag) => {
        let d = this.on('QbXmlRequestUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ReceivePaymentRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onReceivePaymentRemoved = (callback: (arg: QbReceivePaymentDto) => void, bag?: DisposeBag) => {
        let d = this.on('ReceivePaymentRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ReceivePaymentUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onReceivePaymentUpdated = (callback: (arg: QbReceivePaymentDto) => void, bag?: DisposeBag) => {
        let d = this.on('ReceivePaymentUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when ServerVersion is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onServerVersion = (callback: (serverVersion: string) => void, bag?: DisposeBag) => {
        let d = this.on('ServerVersion', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when TxnTemplateOneRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onTxnTemplateOneRemoved = (callback: (arg: TxnTemplateWithHistoryDto) => void, bag?: DisposeBag) => {
        let d = this.on('TxnTemplateOneRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when TxnTemplateOneUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onTxnTemplateOneUpdated = (callback: (arg: TxnTemplateWithHistoryDto) => void, bag?: DisposeBag) => {
        let d = this.on('TxnTemplateOneUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when TxnTemplateRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onTxnTemplateRemoved = (callback: (arg: TxnTemplateDto) => void, bag?: DisposeBag) => {
        let d = this.on('TxnTemplateRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when TxnTemplateUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onTxnTemplateUpdated = (callback: (arg: TxnTemplateDto) => void, bag?: DisposeBag) => {
        let d = this.on('TxnTemplateUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when UserActivityForceClose is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onUserActivityForceClose = (callback: () => void, bag?: DisposeBag) => {
        let d = this.on('UserActivityForceClose', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when UserActivityForceRefresh is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onUserActivityForceRefresh = (callback: () => void, bag?: DisposeBag) => {
        let d = this.on('UserActivityForceRefresh', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when UserActivityRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onUserActivityRemoved = (callback: (uc: UserActivityDto) => void, bag?: DisposeBag) => {
        let d = this.on('UserActivityRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when UserActivityUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onUserActivityUpdated = (callback: (ua: UserActivityDto) => void, bag?: DisposeBag) => {
        let d = this.on('UserActivityUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when UserRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onUserRemoved = (callback: (user: UserFullDto) => void, bag?: DisposeBag) => {
        let d = this.on('UserRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when UserUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onUserUpdated = (callback: (arg: UserFullDto) => void, bag?: DisposeBag) => {
        let d = this.on('UserUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when XheoDebugLogRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onXheoDebugLogRemoved = (callback: (arg: XheoDebugLogDto) => void, bag?: DisposeBag) => {
        let d = this.on('XheoDebugLogRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when XheoDebugLogUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onXheoDebugLogUpdated = (callback: (arg: XheoDebugLogDto) => void, bag?: DisposeBag) => {
        let d = this.on('XheoDebugLogUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when XheoExtensionRemoved is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onXheoExtensionRemoved = (callback: (arg: XheoExtensionDto) => void, bag?: DisposeBag) => {
        let d = this.on('XheoExtensionRemoved', callback);
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Wires up a callback to be invoked when XheoExtensionUpdated is triggered by DataHub
    *
    * @param callback The callback to be invoked.
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    onXheoExtensionUpdated = (callback: (arg: XheoExtensionDto) => void, bag?: DisposeBag) => {
        let d = this.on('XheoExtensionUpdated', callback);
        if(bag) bag.push(d);
        return d;
    }
    

    // convenience methods to bind updates/removes to an array
    
    /**
    * Bind ActivityFullUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of ActivityFullDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindActivityFullUpdated = (arrayFunc: () => Array<ActivityFullDto>, bag?: DisposeBag) => {
        let d = this.on('ActivityFullUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind ActivityTypeUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of ActivityTypeDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindActivityTypeUpdated = (arrayFunc: () => Array<ActivityTypeDto>, bag?: DisposeBag) => {
        let d = this.on('ActivityTypeUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind ActivityUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of ActivityDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindActivityUpdated = (arrayFunc: () => Array<ActivityDto>, bag?: DisposeBag) => {
        let d = this.on('ActivityUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetActivationUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of XheoActivationDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetActivationUpdated = (arrayFunc: () => Array<XheoActivationDto>, bag?: DisposeBag) => {
        let d = this.on('AssetActivationUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.serialNumber);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetEmailLogUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetEmailLogDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetEmailLogUpdated = (arrayFunc: () => Array<AssetEmailLogDto>, bag?: DisposeBag) => {
        let d = this.on('AssetEmailLogUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetEnabledFeatureUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetEnabledFeatureDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetEnabledFeatureUpdated = (arrayFunc: () => Array<AssetEnabledFeatureDto>, bag?: DisposeBag) => {
        let d = this.on('AssetEnabledFeatureUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetLicenseUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetLicenseDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetLicenseUpdated = (arrayFunc: () => Array<AssetLicenseDto>, bag?: DisposeBag) => {
        let d = this.on('AssetLicenseUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetNoteUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetNoteDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetNoteUpdated = (arrayFunc: () => Array<AssetNoteDto>, bag?: DisposeBag) => {
        let d = this.on('AssetNoteUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetPricePlanUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetPricePlanDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetPricePlanUpdated = (arrayFunc: () => Array<AssetPricePlanDto>, bag?: DisposeBag) => {
        let d = this.on('AssetPricePlanUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetProductUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetProductDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetProductUpdated = (arrayFunc: () => Array<AssetProductDto>, bag?: DisposeBag) => {
        let d = this.on('AssetProductUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetStatusUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetStatusDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetStatusUpdated = (arrayFunc: () => Array<AssetStatusDto>, bag?: DisposeBag) => {
        let d = this.on('AssetStatusUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetTransactionUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetTransactionDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetTransactionUpdated = (arrayFunc: () => Array<AssetTransactionDto>, bag?: DisposeBag) => {
        let d = this.on('AssetTransactionUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetTypeUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetTypeDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetTypeUpdated = (arrayFunc: () => Array<AssetTypeDto>, bag?: DisposeBag) => {
        let d = this.on('AssetTypeUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetUpdated = (arrayFunc: () => Array<AssetDto>, bag?: DisposeBag) => {
        let d = this.on('AssetUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AuthorizeNetBatchUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AuthorizeNetBatchDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAuthorizeNetBatchUpdated = (arrayFunc: () => Array<AuthorizeNetBatchDto>, bag?: DisposeBag) => {
        let d = this.on('AuthorizeNetBatchUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AuthorizeNetTransactionUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AuthorizeNetTransactionDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAuthorizeNetTransactionUpdated = (arrayFunc: () => Array<AuthorizeNetTransactionDto>, bag?: DisposeBag) => {
        let d = this.on('AuthorizeNetTransactionUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CasePriorityUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of CasePriorityDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCasePriorityUpdated = (arrayFunc: () => Array<CasePriorityDto>, bag?: DisposeBag) => {
        let d = this.on('CasePriorityUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CaseStatusUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of CaseStatusDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCaseStatusUpdated = (arrayFunc: () => Array<CaseStatusDto>, bag?: DisposeBag) => {
        let d = this.on('CaseStatusUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CaseTypeUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of CaseTypeDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCaseTypeUpdated = (arrayFunc: () => Array<CaseTypeDto>, bag?: DisposeBag) => {
        let d = this.on('CaseTypeUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CaseUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of CaseDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCaseUpdated = (arrayFunc: () => Array<CaseDto>, bag?: DisposeBag) => {
        let d = this.on('CaseUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CompanyUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of CompanyDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCompanyUpdated = (arrayFunc: () => Array<CompanyDto>, bag?: DisposeBag) => {
        let d = this.on('CompanyUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind ContactUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerContactDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindContactUpdated = (arrayFunc: () => Array<QbCustomerContactDto>, bag?: DisposeBag) => {
        let d = this.on('ContactUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CustomerAssetUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AssetDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCustomerAssetUpdated = (arrayFunc: () => Array<AssetDto>, bag?: DisposeBag) => {
        let d = this.on('CustomerAssetUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CustomerPaymentMigrationUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerPaymentMigrationDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCustomerPaymentMigrationUpdated = (arrayFunc: () => Array<QbCustomerPaymentMigrationDto>, bag?: DisposeBag) => {
        let d = this.on('CustomerPaymentMigrationUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CustomerProfileUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AuthorizeNetCustomerProfileDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCustomerProfileUpdated = (arrayFunc: () => Array<AuthorizeNetCustomerProfileDto>, bag?: DisposeBag) => {
        let d = this.on('CustomerProfileUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CustomerTagGroupUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of CustomerTagGroupDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCustomerTagGroupUpdated = (arrayFunc: () => Array<CustomerTagGroupDto>, bag?: DisposeBag) => {
        let d = this.on('CustomerTagGroupUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind InvoiceAutoDebitUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbInvoiceAutoDebitDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindInvoiceAutoDebitUpdated = (arrayFunc: () => Array<QbInvoiceAutoDebitDto>, bag?: DisposeBag) => {
        let d = this.on('InvoiceAutoDebitUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind InvoiceDetailUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbInvoiceDetailDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindInvoiceDetailUpdated = (arrayFunc: () => Array<QbInvoiceDetailDto>, bag?: DisposeBag) => {
        let d = this.on('InvoiceDetailUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind LeadSourceUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of LeadSourceDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindLeadSourceUpdated = (arrayFunc: () => Array<LeadSourceDto>, bag?: DisposeBag) => {
        let d = this.on('LeadSourceUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind LeadStatusUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of LeadStatusDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindLeadStatusUpdated = (arrayFunc: () => Array<LeadStatusDto>, bag?: DisposeBag) => {
        let d = this.on('LeadStatusUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind LeadUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindLeadUpdated = (arrayFunc: () => Array<QbCustomerDto>, bag?: DisposeBag) => {
        let d = this.on('LeadUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind LogUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of LogDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindLogUpdated = (arrayFunc: () => Array<LogDto>, bag?: DisposeBag) => {
        let d = this.on('LogUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.id);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind PaymentDetailUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbReceivePaymentDetailDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindPaymentDetailUpdated = (arrayFunc: () => Array<QbReceivePaymentDetailDto>, bag?: DisposeBag) => {
        let d = this.on('PaymentDetailUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind PaymentMethodUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbPaymentMethodDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindPaymentMethodUpdated = (arrayFunc: () => Array<QbPaymentMethodDto>, bag?: DisposeBag) => {
        let d = this.on('PaymentMethodUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind PaymentProfileUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of AuthorizeNetPaymentProfileDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindPaymentProfileUpdated = (arrayFunc: () => Array<AuthorizeNetPaymentProfileDto>, bag?: DisposeBag) => {
        let d = this.on('PaymentProfileUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbClassUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbClassDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbClassUpdated = (arrayFunc: () => Array<QbClassDto>, bag?: DisposeBag) => {
        let d = this.on('QbClassUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbCustomerMsgUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerMsgDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbCustomerMsgUpdated = (arrayFunc: () => Array<QbCustomerMsgDto>, bag?: DisposeBag) => {
        let d = this.on('QbCustomerMsgUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbCustomerUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbCustomerUpdated = (arrayFunc: () => Array<QbCustomerDto>, bag?: DisposeBag) => {
        let d = this.on('QbCustomerUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbItemSalesTaxUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbItemSalesTaxDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbItemSalesTaxUpdated = (arrayFunc: () => Array<QbItemSalesTaxDto>, bag?: DisposeBag) => {
        let d = this.on('QbItemSalesTaxUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbItemUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbItemDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbItemUpdated = (arrayFunc: () => Array<QbItemDto>, bag?: DisposeBag) => {
        let d = this.on('QbItemUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbPriceLevelUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbPriceLevelDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbPriceLevelUpdated = (arrayFunc: () => Array<QbPriceLevelDto>, bag?: DisposeBag) => {
        let d = this.on('QbPriceLevelUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbSalesRepUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbSalesRepDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbSalesRepUpdated = (arrayFunc: () => Array<QbSalesRepDto>, bag?: DisposeBag) => {
        let d = this.on('QbSalesRepUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbSalesTaxCodeUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbSalesTaxCodeDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbSalesTaxCodeUpdated = (arrayFunc: () => Array<QbSalesTaxCodeDto>, bag?: DisposeBag) => {
        let d = this.on('QbSalesTaxCodeUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbSyncStateUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbSyncStateDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbSyncStateUpdated = (arrayFunc: () => Array<QbSyncStateDto>, bag?: DisposeBag) => {
        let d = this.on('QbSyncStateUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbTemplateUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbTemplateDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbTemplateUpdated = (arrayFunc: () => Array<QbTemplateDto>, bag?: DisposeBag) => {
        let d = this.on('QbTemplateUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbTermsUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbTermsDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbTermsUpdated = (arrayFunc: () => Array<QbTermsDto>, bag?: DisposeBag) => {
        let d = this.on('QbTermsUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbTransactionUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbTransactionDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbTransactionUpdated = (arrayFunc: () => Array<QbTransactionDto>, bag?: DisposeBag) => {
        let d = this.on('QbTransactionUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbXmlRequestUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbXmlRequestDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbXmlRequestUpdated = (arrayFunc: () => Array<QbXmlRequestDto>, bag?: DisposeBag) => {
        let d = this.on('QbXmlRequestUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind ReceivePaymentUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of QbReceivePaymentDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindReceivePaymentUpdated = (arrayFunc: () => Array<QbReceivePaymentDto>, bag?: DisposeBag) => {
        let d = this.on('ReceivePaymentUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind TxnTemplateOneUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of TxnTemplateWithHistoryDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindTxnTemplateOneUpdated = (arrayFunc: () => Array<TxnTemplateWithHistoryDto>, bag?: DisposeBag) => {
        let d = this.on('TxnTemplateOneUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind TxnTemplateUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of TxnTemplateDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindTxnTemplateUpdated = (arrayFunc: () => Array<TxnTemplateDto>, bag?: DisposeBag) => {
        let d = this.on('TxnTemplateUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind UserActivityUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of UserActivityDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindUserActivityUpdated = (arrayFunc: () => Array<UserActivityDto>, bag?: DisposeBag) => {
        let d = this.on('UserActivityUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.connectionId);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind UserUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of UserFullDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindUserUpdated = (arrayFunc: () => Array<UserFullDto>, bag?: DisposeBag) => {
        let d = this.on('UserUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind XheoDebugLogUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of XheoDebugLogDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindXheoDebugLogUpdated = (arrayFunc: () => Array<XheoDebugLogDto>, bag?: DisposeBag) => {
        let d = this.on('XheoDebugLogUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.logID);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind XheoExtensionUpdated to automatically push updates to a local array
    *
    * @param arrayFunc A function that returns the array of XheoExtensionDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindXheoExtensionUpdated = (arrayFunc: () => Array<XheoExtensionDto>, bag?: DisposeBag) => {
        let d = this.on('XheoExtensionUpdated', entity => {
            let array = arrayFunc();
            array.merge(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    

    
    /**
    * Bind ActivityFullRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of ActivityFullDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindActivityFullRemoved = (arrayFunc: () => Array<ActivityFullDto>, bag?: DisposeBag) => {
        let d = this.on('ActivityFullRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind ActivityRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of ActivityDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindActivityRemoved = (arrayFunc: () => Array<ActivityDto>, bag?: DisposeBag) => {
        let d = this.on('ActivityRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind ActivityTypeRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of ActivityTypeDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindActivityTypeRemoved = (arrayFunc: () => Array<ActivityTypeDto>, bag?: DisposeBag) => {
        let d = this.on('ActivityTypeRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetActivationRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of XheoActivationDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetActivationRemoved = (arrayFunc: () => Array<XheoActivationDto>, bag?: DisposeBag) => {
        let d = this.on('AssetActivationRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.serialNumber);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetEmailLogRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetEmailLogDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetEmailLogRemoved = (arrayFunc: () => Array<AssetEmailLogDto>, bag?: DisposeBag) => {
        let d = this.on('AssetEmailLogRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetEnabledFeatureRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetEnabledFeatureDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetEnabledFeatureRemoved = (arrayFunc: () => Array<AssetEnabledFeatureDto>, bag?: DisposeBag) => {
        let d = this.on('AssetEnabledFeatureRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetLicenseRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetLicenseDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetLicenseRemoved = (arrayFunc: () => Array<AssetLicenseDto>, bag?: DisposeBag) => {
        let d = this.on('AssetLicenseRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetNoteRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetNoteDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetNoteRemoved = (arrayFunc: () => Array<AssetNoteDto>, bag?: DisposeBag) => {
        let d = this.on('AssetNoteRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetPricePlanRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetPricePlanDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetPricePlanRemoved = (arrayFunc: () => Array<AssetPricePlanDto>, bag?: DisposeBag) => {
        let d = this.on('AssetPricePlanRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetProductRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetProductDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetProductRemoved = (arrayFunc: () => Array<AssetProductDto>, bag?: DisposeBag) => {
        let d = this.on('AssetProductRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetRemoved = (arrayFunc: () => Array<AssetDto>, bag?: DisposeBag) => {
        let d = this.on('AssetRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetStatusRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetStatusDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetStatusRemoved = (arrayFunc: () => Array<AssetStatusDto>, bag?: DisposeBag) => {
        let d = this.on('AssetStatusRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetTransactionRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetTransactionDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetTransactionRemoved = (arrayFunc: () => Array<AssetTransactionDto>, bag?: DisposeBag) => {
        let d = this.on('AssetTransactionRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AssetTypeRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetTypeDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAssetTypeRemoved = (arrayFunc: () => Array<AssetTypeDto>, bag?: DisposeBag) => {
        let d = this.on('AssetTypeRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AuthorizeNetBatchRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AuthorizeNetBatchDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAuthorizeNetBatchRemoved = (arrayFunc: () => Array<AuthorizeNetBatchDto>, bag?: DisposeBag) => {
        let d = this.on('AuthorizeNetBatchRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind AuthorizeNetTransactionRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AuthorizeNetTransactionDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAuthorizeNetTransactionRemoved = (arrayFunc: () => Array<AuthorizeNetTransactionDto>, bag?: DisposeBag) => {
        let d = this.on('AuthorizeNetTransactionRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CasePriorityRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of CasePriorityDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCasePriorityRemoved = (arrayFunc: () => Array<CasePriorityDto>, bag?: DisposeBag) => {
        let d = this.on('CasePriorityRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CaseRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of CaseDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCaseRemoved = (arrayFunc: () => Array<CaseDto>, bag?: DisposeBag) => {
        let d = this.on('CaseRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CaseStatusRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of CaseStatusDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCaseStatusRemoved = (arrayFunc: () => Array<CaseStatusDto>, bag?: DisposeBag) => {
        let d = this.on('CaseStatusRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CaseTypeRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of CaseTypeDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCaseTypeRemoved = (arrayFunc: () => Array<CaseTypeDto>, bag?: DisposeBag) => {
        let d = this.on('CaseTypeRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CompanyRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of CompanyDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCompanyRemoved = (arrayFunc: () => Array<CompanyDto>, bag?: DisposeBag) => {
        let d = this.on('CompanyRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind ContactRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerContactDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindContactRemoved = (arrayFunc: () => Array<QbCustomerContactDto>, bag?: DisposeBag) => {
        let d = this.on('ContactRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CustomerAssetRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AssetDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCustomerAssetRemoved = (arrayFunc: () => Array<AssetDto>, bag?: DisposeBag) => {
        let d = this.on('CustomerAssetRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CustomerPaymentMigrationRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerPaymentMigrationDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCustomerPaymentMigrationRemoved = (arrayFunc: () => Array<QbCustomerPaymentMigrationDto>, bag?: DisposeBag) => {
        let d = this.on('CustomerPaymentMigrationRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CustomerProfileRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AuthorizeNetCustomerProfileDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCustomerProfileRemoved = (arrayFunc: () => Array<AuthorizeNetCustomerProfileDto>, bag?: DisposeBag) => {
        let d = this.on('CustomerProfileRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind CustomerTagGroupRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of CustomerTagGroupDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindCustomerTagGroupRemoved = (arrayFunc: () => Array<CustomerTagGroupDto>, bag?: DisposeBag) => {
        let d = this.on('CustomerTagGroupRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind InvoiceAutoDebitRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbInvoiceAutoDebitDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindInvoiceAutoDebitRemoved = (arrayFunc: () => Array<QbInvoiceAutoDebitDto>, bag?: DisposeBag) => {
        let d = this.on('InvoiceAutoDebitRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind InvoiceDetailRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbInvoiceDetailDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindInvoiceDetailRemoved = (arrayFunc: () => Array<QbInvoiceDetailDto>, bag?: DisposeBag) => {
        let d = this.on('InvoiceDetailRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind LeadRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindLeadRemoved = (arrayFunc: () => Array<QbCustomerDto>, bag?: DisposeBag) => {
        let d = this.on('LeadRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind LeadSourceRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of LeadSourceDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindLeadSourceRemoved = (arrayFunc: () => Array<LeadSourceDto>, bag?: DisposeBag) => {
        let d = this.on('LeadSourceRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind LeadStatusRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of LeadStatusDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindLeadStatusRemoved = (arrayFunc: () => Array<LeadStatusDto>, bag?: DisposeBag) => {
        let d = this.on('LeadStatusRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind PaymentDetailRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbReceivePaymentDetailDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindPaymentDetailRemoved = (arrayFunc: () => Array<QbReceivePaymentDetailDto>, bag?: DisposeBag) => {
        let d = this.on('PaymentDetailRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind PaymentMethodRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbPaymentMethodDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindPaymentMethodRemoved = (arrayFunc: () => Array<QbPaymentMethodDto>, bag?: DisposeBag) => {
        let d = this.on('PaymentMethodRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind PaymentProfileRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of AuthorizeNetPaymentProfileDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindPaymentProfileRemoved = (arrayFunc: () => Array<AuthorizeNetPaymentProfileDto>, bag?: DisposeBag) => {
        let d = this.on('PaymentProfileRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbClassRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbClassDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbClassRemoved = (arrayFunc: () => Array<QbClassDto>, bag?: DisposeBag) => {
        let d = this.on('QbClassRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbCustomerMsgRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerMsgDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbCustomerMsgRemoved = (arrayFunc: () => Array<QbCustomerMsgDto>, bag?: DisposeBag) => {
        let d = this.on('QbCustomerMsgRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbCustomerRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbCustomerDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbCustomerRemoved = (arrayFunc: () => Array<QbCustomerDto>, bag?: DisposeBag) => {
        let d = this.on('QbCustomerRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbItemRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbItemDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbItemRemoved = (arrayFunc: () => Array<QbItemDto>, bag?: DisposeBag) => {
        let d = this.on('QbItemRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbItemSalesTaxRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbItemSalesTaxDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbItemSalesTaxRemoved = (arrayFunc: () => Array<QbItemSalesTaxDto>, bag?: DisposeBag) => {
        let d = this.on('QbItemSalesTaxRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbPriceLevelRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbPriceLevelDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbPriceLevelRemoved = (arrayFunc: () => Array<QbPriceLevelDto>, bag?: DisposeBag) => {
        let d = this.on('QbPriceLevelRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbSalesRepRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbSalesRepDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbSalesRepRemoved = (arrayFunc: () => Array<QbSalesRepDto>, bag?: DisposeBag) => {
        let d = this.on('QbSalesRepRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbSalesTaxCodeRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbSalesTaxCodeDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbSalesTaxCodeRemoved = (arrayFunc: () => Array<QbSalesTaxCodeDto>, bag?: DisposeBag) => {
        let d = this.on('QbSalesTaxCodeRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbTemplateRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbTemplateDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbTemplateRemoved = (arrayFunc: () => Array<QbTemplateDto>, bag?: DisposeBag) => {
        let d = this.on('QbTemplateRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbTermsRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbTermsDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbTermsRemoved = (arrayFunc: () => Array<QbTermsDto>, bag?: DisposeBag) => {
        let d = this.on('QbTermsRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbTransactionRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbTransactionDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbTransactionRemoved = (arrayFunc: () => Array<QbTransactionDto>, bag?: DisposeBag) => {
        let d = this.on('QbTransactionRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind QbXmlRequestRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbXmlRequestDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindQbXmlRequestRemoved = (arrayFunc: () => Array<QbXmlRequestDto>, bag?: DisposeBag) => {
        let d = this.on('QbXmlRequestRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind ReceivePaymentRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of QbReceivePaymentDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindReceivePaymentRemoved = (arrayFunc: () => Array<QbReceivePaymentDto>, bag?: DisposeBag) => {
        let d = this.on('ReceivePaymentRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind TxnTemplateOneRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of TxnTemplateWithHistoryDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindTxnTemplateOneRemoved = (arrayFunc: () => Array<TxnTemplateWithHistoryDto>, bag?: DisposeBag) => {
        let d = this.on('TxnTemplateOneRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind TxnTemplateRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of TxnTemplateDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindTxnTemplateRemoved = (arrayFunc: () => Array<TxnTemplateDto>, bag?: DisposeBag) => {
        let d = this.on('TxnTemplateRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind UserActivityRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of UserActivityDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindUserActivityRemoved = (arrayFunc: () => Array<UserActivityDto>, bag?: DisposeBag) => {
        let d = this.on('UserActivityRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.connectionId);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind UserRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of UserFullDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindUserRemoved = (arrayFunc: () => Array<UserFullDto>, bag?: DisposeBag) => {
        let d = this.on('UserRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind XheoDebugLogRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of XheoDebugLogDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindXheoDebugLogRemoved = (arrayFunc: () => Array<XheoDebugLogDto>, bag?: DisposeBag) => {
        let d = this.on('XheoDebugLogRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.logID);
        });
        if(bag) bag.push(d);
        return d;
    }
    
    /**
    * Bind XheoExtensionRemoved to automatically remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of XheoExtensionDto to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindXheoExtensionRemoved = (arrayFunc: () => Array<XheoExtensionDto>, bag?: DisposeBag) => {
        let d = this.on('XheoExtensionRemoved', entity => {
            let array = arrayFunc();
            array.remove(entity, x => x.guid);
        });
        if(bag) bag.push(d);
        return d;
    }
    

    
     /**
    * Bind ActivityFull to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[ActivityFullDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllActivityFull = (arrayFunc: () => Array<ActivityFullDto>, bag?: DisposeBag) => {
        this.bindActivityFullRemoved(arrayFunc, bag);
        this.bindActivityFullUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind Activity to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[ActivityDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllActivity = (arrayFunc: () => Array<ActivityDto>, bag?: DisposeBag) => {
        this.bindActivityRemoved(arrayFunc, bag);
        this.bindActivityUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind ActivityType to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[ActivityTypeDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllActivityType = (arrayFunc: () => Array<ActivityTypeDto>, bag?: DisposeBag) => {
        this.bindActivityTypeRemoved(arrayFunc, bag);
        this.bindActivityTypeUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetActivation to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[XheoActivationDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetActivation = (arrayFunc: () => Array<XheoActivationDto>, bag?: DisposeBag) => {
        this.bindAssetActivationRemoved(arrayFunc, bag);
        this.bindAssetActivationUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetEmailLog to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetEmailLogDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetEmailLog = (arrayFunc: () => Array<AssetEmailLogDto>, bag?: DisposeBag) => {
        this.bindAssetEmailLogRemoved(arrayFunc, bag);
        this.bindAssetEmailLogUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetEnabledFeature to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetEnabledFeatureDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetEnabledFeature = (arrayFunc: () => Array<AssetEnabledFeatureDto>, bag?: DisposeBag) => {
        this.bindAssetEnabledFeatureRemoved(arrayFunc, bag);
        this.bindAssetEnabledFeatureUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetLicense to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetLicenseDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetLicense = (arrayFunc: () => Array<AssetLicenseDto>, bag?: DisposeBag) => {
        this.bindAssetLicenseRemoved(arrayFunc, bag);
        this.bindAssetLicenseUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetNote to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetNoteDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetNote = (arrayFunc: () => Array<AssetNoteDto>, bag?: DisposeBag) => {
        this.bindAssetNoteRemoved(arrayFunc, bag);
        this.bindAssetNoteUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetPricePlan to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetPricePlanDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetPricePlan = (arrayFunc: () => Array<AssetPricePlanDto>, bag?: DisposeBag) => {
        this.bindAssetPricePlanRemoved(arrayFunc, bag);
        this.bindAssetPricePlanUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetProduct to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetProductDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetProduct = (arrayFunc: () => Array<AssetProductDto>, bag?: DisposeBag) => {
        this.bindAssetProductRemoved(arrayFunc, bag);
        this.bindAssetProductUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind Asset to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAsset = (arrayFunc: () => Array<AssetDto>, bag?: DisposeBag) => {
        this.bindAssetRemoved(arrayFunc, bag);
        this.bindAssetUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetStatus to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetStatusDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetStatus = (arrayFunc: () => Array<AssetStatusDto>, bag?: DisposeBag) => {
        this.bindAssetStatusRemoved(arrayFunc, bag);
        this.bindAssetStatusUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetTransaction to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetTransactionDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetTransaction = (arrayFunc: () => Array<AssetTransactionDto>, bag?: DisposeBag) => {
        this.bindAssetTransactionRemoved(arrayFunc, bag);
        this.bindAssetTransactionUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AssetType to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetTypeDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAssetType = (arrayFunc: () => Array<AssetTypeDto>, bag?: DisposeBag) => {
        this.bindAssetTypeRemoved(arrayFunc, bag);
        this.bindAssetTypeUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AuthorizeNetBatch to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AuthorizeNetBatchDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAuthorizeNetBatch = (arrayFunc: () => Array<AuthorizeNetBatchDto>, bag?: DisposeBag) => {
        this.bindAuthorizeNetBatchRemoved(arrayFunc, bag);
        this.bindAuthorizeNetBatchUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind AuthorizeNetTransaction to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AuthorizeNetTransactionDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllAuthorizeNetTransaction = (arrayFunc: () => Array<AuthorizeNetTransactionDto>, bag?: DisposeBag) => {
        this.bindAuthorizeNetTransactionRemoved(arrayFunc, bag);
        this.bindAuthorizeNetTransactionUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind CasePriority to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[CasePriorityDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCasePriority = (arrayFunc: () => Array<CasePriorityDto>, bag?: DisposeBag) => {
        this.bindCasePriorityRemoved(arrayFunc, bag);
        this.bindCasePriorityUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind Case to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[CaseDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCase = (arrayFunc: () => Array<CaseDto>, bag?: DisposeBag) => {
        this.bindCaseRemoved(arrayFunc, bag);
        this.bindCaseUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind CaseStatus to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[CaseStatusDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCaseStatus = (arrayFunc: () => Array<CaseStatusDto>, bag?: DisposeBag) => {
        this.bindCaseStatusRemoved(arrayFunc, bag);
        this.bindCaseStatusUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind CaseType to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[CaseTypeDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCaseType = (arrayFunc: () => Array<CaseTypeDto>, bag?: DisposeBag) => {
        this.bindCaseTypeRemoved(arrayFunc, bag);
        this.bindCaseTypeUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind Company to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[CompanyDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCompany = (arrayFunc: () => Array<CompanyDto>, bag?: DisposeBag) => {
        this.bindCompanyRemoved(arrayFunc, bag);
        this.bindCompanyUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind Contact to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbCustomerContactDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllContact = (arrayFunc: () => Array<QbCustomerContactDto>, bag?: DisposeBag) => {
        this.bindContactRemoved(arrayFunc, bag);
        this.bindContactUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind CustomerAsset to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AssetDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCustomerAsset = (arrayFunc: () => Array<AssetDto>, bag?: DisposeBag) => {
        this.bindCustomerAssetRemoved(arrayFunc, bag);
        this.bindCustomerAssetUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind CustomerPaymentMigration to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbCustomerPaymentMigrationDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCustomerPaymentMigration = (arrayFunc: () => Array<QbCustomerPaymentMigrationDto>, bag?: DisposeBag) => {
        this.bindCustomerPaymentMigrationRemoved(arrayFunc, bag);
        this.bindCustomerPaymentMigrationUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind CustomerProfile to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AuthorizeNetCustomerProfileDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCustomerProfile = (arrayFunc: () => Array<AuthorizeNetCustomerProfileDto>, bag?: DisposeBag) => {
        this.bindCustomerProfileRemoved(arrayFunc, bag);
        this.bindCustomerProfileUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind CustomerTagGroup to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[CustomerTagGroupDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllCustomerTagGroup = (arrayFunc: () => Array<CustomerTagGroupDto>, bag?: DisposeBag) => {
        this.bindCustomerTagGroupRemoved(arrayFunc, bag);
        this.bindCustomerTagGroupUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind InvoiceAutoDebit to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbInvoiceAutoDebitDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllInvoiceAutoDebit = (arrayFunc: () => Array<QbInvoiceAutoDebitDto>, bag?: DisposeBag) => {
        this.bindInvoiceAutoDebitRemoved(arrayFunc, bag);
        this.bindInvoiceAutoDebitUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind InvoiceDetail to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbInvoiceDetailDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllInvoiceDetail = (arrayFunc: () => Array<QbInvoiceDetailDto>, bag?: DisposeBag) => {
        this.bindInvoiceDetailRemoved(arrayFunc, bag);
        this.bindInvoiceDetailUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind Lead to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbCustomerDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllLead = (arrayFunc: () => Array<QbCustomerDto>, bag?: DisposeBag) => {
        this.bindLeadRemoved(arrayFunc, bag);
        this.bindLeadUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind LeadSource to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[LeadSourceDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllLeadSource = (arrayFunc: () => Array<LeadSourceDto>, bag?: DisposeBag) => {
        this.bindLeadSourceRemoved(arrayFunc, bag);
        this.bindLeadSourceUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind LeadStatus to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[LeadStatusDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllLeadStatus = (arrayFunc: () => Array<LeadStatusDto>, bag?: DisposeBag) => {
        this.bindLeadStatusRemoved(arrayFunc, bag);
        this.bindLeadStatusUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind Log to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[LogDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllLog = (arrayFunc: () => Array<LogDto>, bag?: DisposeBag) => {
        this.bindLogUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind PaymentDetail to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbReceivePaymentDetailDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllPaymentDetail = (arrayFunc: () => Array<QbReceivePaymentDetailDto>, bag?: DisposeBag) => {
        this.bindPaymentDetailRemoved(arrayFunc, bag);
        this.bindPaymentDetailUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind PaymentMethod to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbPaymentMethodDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllPaymentMethod = (arrayFunc: () => Array<QbPaymentMethodDto>, bag?: DisposeBag) => {
        this.bindPaymentMethodRemoved(arrayFunc, bag);
        this.bindPaymentMethodUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind PaymentProfile to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[AuthorizeNetPaymentProfileDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllPaymentProfile = (arrayFunc: () => Array<AuthorizeNetPaymentProfileDto>, bag?: DisposeBag) => {
        this.bindPaymentProfileRemoved(arrayFunc, bag);
        this.bindPaymentProfileUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbClass to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbClassDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbClass = (arrayFunc: () => Array<QbClassDto>, bag?: DisposeBag) => {
        this.bindQbClassRemoved(arrayFunc, bag);
        this.bindQbClassUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbCustomerMsg to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbCustomerMsgDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbCustomerMsg = (arrayFunc: () => Array<QbCustomerMsgDto>, bag?: DisposeBag) => {
        this.bindQbCustomerMsgRemoved(arrayFunc, bag);
        this.bindQbCustomerMsgUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbCustomer to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbCustomerDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbCustomer = (arrayFunc: () => Array<QbCustomerDto>, bag?: DisposeBag) => {
        this.bindQbCustomerRemoved(arrayFunc, bag);
        this.bindQbCustomerUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbItem to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbItemDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbItem = (arrayFunc: () => Array<QbItemDto>, bag?: DisposeBag) => {
        this.bindQbItemRemoved(arrayFunc, bag);
        this.bindQbItemUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbItemSalesTax to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbItemSalesTaxDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbItemSalesTax = (arrayFunc: () => Array<QbItemSalesTaxDto>, bag?: DisposeBag) => {
        this.bindQbItemSalesTaxRemoved(arrayFunc, bag);
        this.bindQbItemSalesTaxUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbPriceLevel to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbPriceLevelDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbPriceLevel = (arrayFunc: () => Array<QbPriceLevelDto>, bag?: DisposeBag) => {
        this.bindQbPriceLevelRemoved(arrayFunc, bag);
        this.bindQbPriceLevelUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbSalesRep to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbSalesRepDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbSalesRep = (arrayFunc: () => Array<QbSalesRepDto>, bag?: DisposeBag) => {
        this.bindQbSalesRepRemoved(arrayFunc, bag);
        this.bindQbSalesRepUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbSalesTaxCode to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbSalesTaxCodeDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbSalesTaxCode = (arrayFunc: () => Array<QbSalesTaxCodeDto>, bag?: DisposeBag) => {
        this.bindQbSalesTaxCodeRemoved(arrayFunc, bag);
        this.bindQbSalesTaxCodeUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbSyncState to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbSyncStateDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbSyncState = (arrayFunc: () => Array<QbSyncStateDto>, bag?: DisposeBag) => {
        this.bindQbSyncStateUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbTemplate to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbTemplateDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbTemplate = (arrayFunc: () => Array<QbTemplateDto>, bag?: DisposeBag) => {
        this.bindQbTemplateRemoved(arrayFunc, bag);
        this.bindQbTemplateUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbTerms to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbTermsDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbTerms = (arrayFunc: () => Array<QbTermsDto>, bag?: DisposeBag) => {
        this.bindQbTermsRemoved(arrayFunc, bag);
        this.bindQbTermsUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbTransaction to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbTransactionDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbTransaction = (arrayFunc: () => Array<QbTransactionDto>, bag?: DisposeBag) => {
        this.bindQbTransactionRemoved(arrayFunc, bag);
        this.bindQbTransactionUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind QbXmlRequest to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbXmlRequestDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllQbXmlRequest = (arrayFunc: () => Array<QbXmlRequestDto>, bag?: DisposeBag) => {
        this.bindQbXmlRequestRemoved(arrayFunc, bag);
        this.bindQbXmlRequestUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind ReceivePayment to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[QbReceivePaymentDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllReceivePayment = (arrayFunc: () => Array<QbReceivePaymentDto>, bag?: DisposeBag) => {
        this.bindReceivePaymentRemoved(arrayFunc, bag);
        this.bindReceivePaymentUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind TxnTemplateOne to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[TxnTemplateWithHistoryDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllTxnTemplateOne = (arrayFunc: () => Array<TxnTemplateWithHistoryDto>, bag?: DisposeBag) => {
        this.bindTxnTemplateOneRemoved(arrayFunc, bag);
        this.bindTxnTemplateOneUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind TxnTemplate to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[TxnTemplateDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllTxnTemplate = (arrayFunc: () => Array<TxnTemplateDto>, bag?: DisposeBag) => {
        this.bindTxnTemplateRemoved(arrayFunc, bag);
        this.bindTxnTemplateUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind UserActivity to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[UserActivityDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllUserActivity = (arrayFunc: () => Array<UserActivityDto>, bag?: DisposeBag) => {
        this.bindUserActivityRemoved(arrayFunc, bag);
        this.bindUserActivityUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind User to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[UserFullDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllUser = (arrayFunc: () => Array<UserFullDto>, bag?: DisposeBag) => {
        this.bindUserRemoved(arrayFunc, bag);
        this.bindUserUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind XheoDebugLog to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[XheoDebugLogDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllXheoDebugLog = (arrayFunc: () => Array<XheoDebugLogDto>, bag?: DisposeBag) => {
        this.bindXheoDebugLogRemoved(arrayFunc, bag);
        this.bindXheoDebugLogUpdated(arrayFunc, bag);
        
    }
    
     /**
    * Bind XheoExtension to automatically add/update/remove entries from a local array
    *
    * @param arrayFunc A function that returns the array of $Parameters()[XheoExtensionDto] to update
    * @param bag An optional DisposeBag to add the IDeferred to
    */
    bindAllXheoExtension = (arrayFunc: () => Array<XheoExtensionDto>, bag?: DisposeBag) => {
        this.bindXheoExtensionRemoved(arrayFunc, bag);
        this.bindXheoExtensionUpdated(arrayFunc, bag);
        
    }
    



}
